const altadecontenido = {
    ContenidosDeLaPaginaWeb: 'SICPO/AltaDeContenido/GetContenidosComunicadosDePaginaWeb',
    AltaDeContenidoDePaginaWeb: 'SICPO/AltaDeContenido/AltaDeContenidoDePaginaWeb',
    ObtenerTipoDeFormularioContenido: 'SICPO/AltaDeContenido/GetTipoDeFormularioContenido',
    ModificarOrdenDeContenidosComunicados: 'SICPO/AltaDeContenido/ModificarOrdenDeContenidosComunicadosDePaginaWeb',
    ModificarOrdenDeContenidosNuevoContenido: 'SICPO/AltaDeContenido/ModificarOrdenDeContenidosNuevoContenido',
    ModificarEstatusDeSeccion: 'SICPO/AltaDeContenido/ModificarEstatusDeSeccion',
    ObtenerCamposRequeridosParaFormulario: 'SICPO/AltaDeContenido/GetCamposRequeridosParaFormulario'
}

export default altadecontenido;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICPO/sistema/paginaweb/altadecontenido/altadecontenido.js
// module id = null
// module chunks = 